module.exports = __webpack_public_path__ + "img/cmp_no mission@3x.10ddfeeb.png";